import { useState } from 'react';
import { Lock, Plus } from 'lucide-react';
import { Button } from '../components/ui/button';
import {} from '../components/common';
import { useLab } from '../lib/service';
import {} from '../shared';

/** Member access, roles and workspace configuration. */
export function Settings({ onError }: { onError: (e: unknown) => void }) {
  const lab = useLab();
  const [email, setEmail] = useState(''),
    [role, setRole] = useState('editor');
  return (
    <>
      <div className="page-heading">
        <div>
          <span className="eyebrow">YOUR STUDIO</span>
          <h1>
            Workspace settings<span>.</span>
          </h1>
          <p>A private place to make something new.</p>
        </div>
      </div>
      <div className="settings-grid">
        <div className="paper-panel">
          <h2>Approved accounts</h2>
          <p className="muted">Email and password. Access is checked on every backend request.</p>
          {lab.home?.access.role === 'owner' ? (
            <>
              {lab.members?.map((m) => (
                <div className="member-row" key={m.email}>
                  <span className="avatar">{m.email[0].toUpperCase()}</span>
                  <span>
                    {m.email}
                    <small>
                      {m.role} · {m.active ? 'Active' : 'Revoked'}
                    </small>
                  </span>
                  {m.role !== 'owner' && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => void lab.setMember({ ...m, active: !m.active }).catch(onError)}
                    >
                      {m.active ? 'Revoke' : 'Restore'}
                    </Button>
                  )}
                </div>
              ))}
              <form
                className="member-form"
                onSubmit={(e) => {
                  e.preventDefault();
                  void lab
                    .setMember({ email, role, active: true })
                    .then(() => setEmail(''))
                    .catch(onError);
                }}
              >
                <input
                  type="email"
                  aria-label="Approved email address"
                  placeholder="collaborator@gmail.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <select
                  aria-label="Member role"
                  value={role}
                  onChange={(e) => setRole(e.target.value)}
                >
                  <option value="editor">Editor</option>
                  <option value="reviewer">Reviewer</option>
                </select>
                <Button type="submit">
                  <Plus size={15} />
                  Add
                </Button>
              </form>
            </>
          ) : (
            <p>Only the workspace owner can manage access.</p>
          )}
        </div>
        <div className="paper-panel">
          <h2>Staged infrastructure</h2>
          {[
            ['Authentication', 'Convex Auth + password'],
            ['Application data', 'Convex · free tier'],
            ['Orchestration', 'Cloudflare Workflows · free tier'],
            ['Media storage', 'Private Cloudflare R2'],
            ['Production compute', 'Your local computer'],
            ['Paid hosting', 'Deferred · requires approval'],
          ].map(([k, v]) => (
            <div className="setting-row" key={k}>
              <span>{k}</span>
              <strong>{v}</strong>
            </div>
          ))}
          <div className="notice">
            <Lock size={17} />
            <span>
              Infisical supplies secrets to each service at runtime. Never enter API keys into this
              interface.
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
